import React from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

import Ticket from './Ticket';
import T001 from './T001';
import T002 from './T002';
import T003 from './T003';

const Router = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/ticket" element={<Ticket />} />
      <Route path="/t001/:deviceId/:queueId/:myTicket" element={<T001 />} />
      <Route path="/t002/:deviceId/:queueId/:myTicket" element={<T002 />} />
      <Route path="/t003/:deviceId/:queueId/:myTicket" element={<T003 />} />
    </Routes>
  </BrowserRouter>
);

export default Router